import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_22566_15964)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M23.7682 12.2743C23.7682 11.4586 23.7021 10.6384 23.561 9.83594H12.2422V14.4569H18.7239C18.455 15.9473 17.5907 17.2657 16.3252 18.1034V21.1018H20.1922C22.463 19.0118 23.7682 15.9252 23.7682 12.2743Z",
					fill: "#4285F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.2391 23.9974C15.4756 23.9974 18.205 22.9348 20.1936 21.1005L16.3266 18.1021C15.2507 18.8341 13.8618 19.2486 12.2435 19.2486C9.11291 19.2486 6.45849 17.1365 5.50607 14.2969H1.51562V17.3878C3.55274 21.44 7.70192 23.9974 12.2391 23.9974Z",
					fill: "#34A853"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.50473 14.3027C5.00206 12.8123 5.00206 11.1985 5.50473 9.70813V6.61719H1.51869C-0.183313 10.008 -0.183313 14.0028 1.51869 17.3936L5.50473 14.3027Z",
					fill: "#FBBC04"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.2391 4.74966C13.9499 4.7232 15.6034 5.36697 16.8425 6.54867L20.2685 3.12262C18.0991 1.0855 15.2198 -0.034466 12.2391 0.000808666C7.70192 0.000808666 3.55274 2.55822 1.51562 6.61481L5.50166 9.70575C6.44967 6.86173 9.1085 4.74966 12.2391 4.74966Z",
					fill: "#EA4335"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_22566_15964",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
